import React, { Component } from "react";
import { connect } from "react-redux";
import { Modal } from "react-bootstrap";

import { createAction } from "utils";
import TicketInfoSection from "./TicketInfoSection";

@connect(({ campaignDetail }) => ({ ...campaignDetail }))
class BuyTicketModal extends Component {

  componentDidMount() {
    this.props.dispatch(
      createAction("campaignDetail/getCampaignDetail")({
        campaignID: this.props.campaignID,
      })
    );
  }

  componentWillUnmount() {
  }

  render() {
    const campaginData = this.props?.[this.props.campaignID]?.data || {};
    const getModalContent = () => {
      return (
        <div>
          <TicketInfoSection 
            detailData={campaginData?.ticket}
          />
        </div>
      )
    }

    return (
      <Modal
        show={this.props.show || false}
        className={'buy-coupon-modal'}
        onHide={this.props.onHide || (() => { this.props.onHide() })}
        scrollable={false}
      >
        {getModalContent()}
      </Modal>
    );
  }
}

export default BuyTicketModal;
